import { render, staticRenderFns } from "./NonModalDialog.vue?vue&type=template&id=6ab2ae9c&scoped=true"
import script from "./NonModalDialog.vue?vue&type=script&lang=js"
export * from "./NonModalDialog.vue?vue&type=script&lang=js"
import style0 from "./NonModalDialog.vue?vue&type=style&index=0&id=6ab2ae9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/lyb/工作/个人/leo——im/新版代码/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab2ae9c",
  null
  
)

export default component.exports